// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.categories-header {
  margin: 0 auto;
  padding: 15px 0px;
  font-size: 35px;
  font-weight: var(--roboto-medium);
}

.categories-info-text {
  color: var(--secondary-text);
  font-size: 20px;
  font-weight: var(--roboto-light);
  margin-top: 5px;
  margin-bottom: 25px;
}

#category-cards {
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  max-width: 1520px;
  width: calc(100% - 20px);
  margin: 0 auto;
  padding: 15px;
}

#category-cards:hover > .category-card::after {
  opacity: 1;
}

.category-card {
  border-radius: 15px;
  cursor: pointer;
  display: flex;
  height: 200px;
  flex-direction: column;
  position: relative;
  width: 200px;
}

.category-card:hover::before {
  opacity: 1;
}

.category-card::before,
.category-card::after {
  border-radius: inherit;
  content: "";
  height: 100%;
  left: 0px;
  opacity: 0;
  position: absolute;
  top: 0px;
  transition: opacity 500ms;
  width: 100%;
}

.category-card::before {
  background: radial-gradient(
    1300px circle at var(--mouse-x) var(--mouse-y),
    rgba(255, 255, 255, 0.2),
    transparent 40%
  );
  z-index: 3;
}

.category-card::after {
  background: radial-gradient(
    600px circle at var(--mouse-x) var(--mouse-y),
    rgba(255, 255, 255, 0.9),
    transparent 40%
  );
  z-index: 1;
}

.category-card > .category-card-content {
  background-color: var(--bg-color);
  border-radius: inherit;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  inset: 1px;
  padding: 10px;
  position: absolute;
  z-index: 2;
}

h3 {
  color: var(--primary-text);
  font-weight: var(--roboto-medium);
  margin: 0px;
  margin-bottom: 20px;
}

.category-card-image {
  align-items: center;
  display: flex;
  height: 200px;
  justify-content: center;
  overflow: hidden;
  color: var(--primary-color);
  z-index: -1;
}

.category-card-info-wrapper {
  align-items: center;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  padding: 0px 20px;
  max-height: 40px;
}

.category-card-info {
  align-items: flex-start;
  display: flex;
}

.category-card-info-title > h3 {
  font-size: 1.1em;
  line-height: 20px;
}

@media (max-width: 1630px) {
  #category-cards {
    max-width: 1080px;
  }
}

@media (max-width: 1300px) {
  #category-cards {
    max-width: 860px;
  }
}

@media (max-width: 900px) {
  #category-cards {
    max-width: 640px;
  }
}

@media (max-width: 700px) {
  #category-cards {
    max-width: 420px;
  }
}

@media (max-width: 500px) {
  #category-cards {
    max-width: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/categories/Categories.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;;;;GAIC;EACD,UAAU;AACZ;;AAEA;EACE;;;;GAIC;EACD,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".categories-header {\r\n  margin: 0 auto;\r\n  padding: 15px 0px;\r\n  font-size: 35px;\r\n  font-weight: var(--roboto-medium);\r\n}\r\n\r\n.categories-info-text {\r\n  color: var(--secondary-text);\r\n  font-size: 20px;\r\n  font-weight: var(--roboto-light);\r\n  margin-top: 5px;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n#category-cards {\r\n  text-align: center;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 20px;\r\n  max-width: 1520px;\r\n  width: calc(100% - 20px);\r\n  margin: 0 auto;\r\n  padding: 15px;\r\n}\r\n\r\n#category-cards:hover > .category-card::after {\r\n  opacity: 1;\r\n}\r\n\r\n.category-card {\r\n  border-radius: 15px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  height: 200px;\r\n  flex-direction: column;\r\n  position: relative;\r\n  width: 200px;\r\n}\r\n\r\n.category-card:hover::before {\r\n  opacity: 1;\r\n}\r\n\r\n.category-card::before,\r\n.category-card::after {\r\n  border-radius: inherit;\r\n  content: \"\";\r\n  height: 100%;\r\n  left: 0px;\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 0px;\r\n  transition: opacity 500ms;\r\n  width: 100%;\r\n}\r\n\r\n.category-card::before {\r\n  background: radial-gradient(\r\n    1300px circle at var(--mouse-x) var(--mouse-y),\r\n    rgba(255, 255, 255, 0.2),\r\n    transparent 40%\r\n  );\r\n  z-index: 3;\r\n}\r\n\r\n.category-card::after {\r\n  background: radial-gradient(\r\n    600px circle at var(--mouse-x) var(--mouse-y),\r\n    rgba(255, 255, 255, 0.9),\r\n    transparent 40%\r\n  );\r\n  z-index: 1;\r\n}\r\n\r\n.category-card > .category-card-content {\r\n  background-color: var(--bg-color);\r\n  border-radius: inherit;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-grow: 1;\r\n  inset: 1px;\r\n  padding: 10px;\r\n  position: absolute;\r\n  z-index: 2;\r\n}\r\n\r\nh3 {\r\n  color: var(--primary-text);\r\n  font-weight: var(--roboto-medium);\r\n  margin: 0px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.category-card-image {\r\n  align-items: center;\r\n  display: flex;\r\n  height: 200px;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n  color: var(--primary-color);\r\n  z-index: -1;\r\n}\r\n\r\n.category-card-info-wrapper {\r\n  align-items: center;\r\n  display: flex;\r\n  flex-grow: 1;\r\n  justify-content: center;\r\n  padding: 0px 20px;\r\n  max-height: 40px;\r\n}\r\n\r\n.category-card-info {\r\n  align-items: flex-start;\r\n  display: flex;\r\n}\r\n\r\n.category-card-info-title > h3 {\r\n  font-size: 1.1em;\r\n  line-height: 20px;\r\n}\r\n\r\n@media (max-width: 1630px) {\r\n  #category-cards {\r\n    max-width: 1080px;\r\n  }\r\n}\r\n\r\n@media (max-width: 1300px) {\r\n  #category-cards {\r\n    max-width: 860px;\r\n  }\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  #category-cards {\r\n    max-width: 640px;\r\n  }\r\n}\r\n\r\n@media (max-width: 700px) {\r\n  #category-cards {\r\n    max-width: 420px;\r\n  }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n  #category-cards {\r\n    max-width: 200px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
